export const GET_LIST_LOADING_TAG: string = 'get-list-loader-tag';
export const LISTS_LOADING_TAG: string = 'lists-loading-tag'